import React from "react";
import axios from "axios";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import DefaultButton from "../../styles/materialButtonStyle";
import { parseAxiosError } from "../../../utils/response";
import { STANDARD_ERRORS_WAY } from "../../../utils/consts";
import { useTranslation } from "react-i18next";

const RetryCallbackButton = ({ id, type, setNotification, notification }) => {
  const { t } = useTranslation("otherInterface");

  const handleRetryCallback = () => {
    axios.get("/api/" + type + "/retry-callback/" + id, userAuthenticationConfig()).then(response => {
      if (response.status === 204) {
        setNotification({ ...notification, visible: true, type: "success", message: t("callbackButton.success") });
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  return (
    <DefaultButton
      color="success"
      onClick={handleRetryCallback}
    >
      <span className="icon-light-reload" />
      Retry Callback
    </DefaultButton>
  );
};

export default RetryCallbackButton;